import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useGetSchoolStudentsQuery } from '../../store/api/schoolAdminApi'
import { useSchoolFilters } from '../../components/school/SchoolLayout'
import DateRangeBar from '../../components/school/DateRangeBar'
import { formatDate, EmptyState, DemoBanner } from '../../components/school/SchoolUi'

const SchoolStudents: React.FC = () => {
  const { t } = useTranslation('school')
  const { filters } = useSchoolFilters()
  const { data, isLoading } = useGetSchoolStudentsQuery(filters)

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">{t('students.title')}</h1>
        <p className="text-gray-600">{t('students.subtitle')}</p>
      </div>
      {data?.isDemo ? <DemoBanner label={t('common.demoBanner')} /> : null}
      <DateRangeBar />
      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
        {isLoading ? (
          <div className="p-8 text-gray-500">{t('common.loading')}</div>
        ) : !(data?.students || []).length ? (
          <EmptyState title={t('students.empty')} hint={t('students.emptyHint')} />
        ) : (
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t('students.columns.student')}</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t('students.columns.class')}</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t('students.columns.activities')}</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t('students.columns.aiSessions')}</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t('students.columns.interactions')}</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t('students.columns.lastActivity')}</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data.students.map((row: any) => (
                <tr key={row.userId} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm">
                    <Link to={`/pending/students/${row.userId}`} className="text-blue-600 hover:underline font-medium">{row.name}</Link>
                  </td>
                  <td className="px-4 py-3 text-sm">{row.classNames || t('common.na')}</td>
                  <td className="px-4 py-3 text-sm">{row.activities}</td>
                  <td className="px-4 py-3 text-sm">{row.aiSessions}</td>
                  <td className="px-4 py-3 text-sm">{row.interactions}</td>
                  <td className="px-4 py-3 text-sm">{formatDate(row.lastActivity)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}

export default SchoolStudents
